import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
// import logo from '@/assets/img/logo.png';
import SvgIcon from '../common/SvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomControl',
  props: {
    givenRoomId: null,
    majorRoomId: null
  },
  emits: ['create-room', 'enter-room'],
  setup(__props: any, { emit }) {

const props = __props as {
  givenRoomId: string | null,
  majorRoomId: string | null,
}



const hasGivenRoomId = computed(() => typeof props.givenRoomId === 'string' && props.givenRoomId !== '');
const hasMajorRoomId = computed(() => typeof props.majorRoomId === 'string' && props.majorRoomId !== '');

const roomId = ref(props.majorRoomId);
const showCreateRoomOption = ref(false);

function handleMouseEnter() {
  showCreateRoomOption.value = true;
}

function handleMouseLeave() {
  showCreateRoomOption.value = false;
}

watch(roomId, (val) => {
  roomId.value = val.replace(/[^\d]/g, '');
});



function enterGivenRoom() {
  emit('enter-room', props.givenRoomId);
}
function enterMajorRoom() {
  emit('enter-room', props.majorRoomId);
}

function createRoom(mode: string) {
  emit('create-room', mode);
}

function enterRoom() {
  if (!roomId.value) {
    return;
  }
  emit('enter-room', Number(roomId.value));
}


return { __sfc: true,props, hasGivenRoomId, hasMajorRoomId, roomId, showCreateRoomOption, handleMouseEnter, handleMouseLeave, emit, enterGivenRoom, enterMajorRoom, createRoom, enterRoom }
}

})